/* Actions commit mutations. Mutations define what the new state is.
Actions tell you when to change them. Actions are triggered throught the store.dispatch method */
import firebase from "firebase";
import TYPES from "./mutation-types";

export default {
  login({ commit }, user) {
    commit(TYPES.LOGIN, user);
  },
  logout({ commit }) {
    firebase.auth().signOut();
    commit(TYPES.LOGOUT);
  },
  subscribeToMomentReminders({ commit }) {
    commit(TYPES.SUBSCRIBE_TO_MOMENT_REMINDERS);
  },
  setSelectedDate({ commit }, newDate) {
    commit(TYPES.SETDATE, newDate);
  },
  setSelectedPeriod({ commit }, period) {
    commit(TYPES.SETPERIOD, period);
  },
  setCookieConsented({ commit }) {
    commit(TYPES.SET_COOKIE_CONSENT);
  },
  deleteUser({ state }) {
    if (!state.user || !state.user.userId) {
      if (window.console.warn) {
        window.console.warn("no user while getting moments");
      }
      return false;
    }

    return state.db
      .collection("moments")
      .where("userId", "==", state.user.userId)
      .get()
      .then(querySnapshot => {
        // Once we get the results, begin a batch
        const batch = state.db.batch();

        querySnapshot.forEach(doc => {
          // For each doc, add a delete operation to the batch
          batch.delete(doc.ref);
        });

        // Commit the batch
        return batch.commit();
      });
  }
};
